import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import '@fontsource/cormorant-garamond/latin-400.css';
import '@fontsource/cormorant-garamond/latin-400-italic.css';
import '@fontsource/manrope/latin-400.css';
import '@fontsource/manrope/latin-500.css';
import App from './App.jsx';
import Creator from './Creator.jsx';
import './styles.css';

const root = document.getElementById('root');
const creatorPage = /^\/nechecode(?:\/|$)/.test(window.location.pathname);
if (creatorPage) document.title = 'NecheCode · Design & development';
const app = <React.StrictMode>{creatorPage ? <Creator /> : <App />}</React.StrictMode>;
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
